"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRequest = exports.useAuthedRequest = exports.request = exports.defaultHeaders = exports.impersonateStorageType = exports.impersonatingId = exports.isImpersonating = exports.stopImpersonating = exports.impersonate = exports.getHostInfo = exports.IMPERSONATE_KEY = void 0;
var luxon_1 = require("luxon");
var api_token_1 = require("./api-token");
var cookies_1 = require("./cookies");
var session_1 = require("./session");
var browser_1 = require("./browser");
var ApplicationError_1 = __importDefault(require("./ApplicationError"));
exports.IMPERSONATE_KEY = 'impersonate_id';
var getHostInfo = function (uri) {
    var url = new URL(uri);
    return __assign({ secure: url.protocol === 'https:' }, (url.hostname !== 'localhost' && {
        domain: url.hostname.split('.').slice(-2).join('.'),
    }));
};
exports.getHostInfo = getHostInfo;
var impersonate = function (userId, _a) {
    var apiBase = _a.apiBase, storage = _a.storage;
    if (storage === 'session') {
        (0, session_1.setSessionKey)({
            name: exports.IMPERSONATE_KEY,
            value: userId,
            expireAt: luxon_1.DateTime.local().plus({ minutes: 30 }),
        });
    }
    else {
        (0, cookies_1.setCookie)(__assign({ name: exports.IMPERSONATE_KEY, value: userId, 
            // 30 minutes
            expiresInSeconds: 30 * 60 }, (0, exports.getHostInfo)(apiBase)));
    }
};
exports.impersonate = impersonate;
var stopImpersonating = function (apiBase) {
    (0, session_1.clearSessionKey)(exports.IMPERSONATE_KEY);
    (0, cookies_1.clearCookie)(__assign({ name: exports.IMPERSONATE_KEY }, (0, exports.getHostInfo)(apiBase)));
};
exports.stopImpersonating = stopImpersonating;
var isImpersonating = function () { return !!(0, exports.impersonatingId)(); };
exports.isImpersonating = isImpersonating;
var impersonatingId = function () {
    return (0, session_1.getSessionKey)(exports.IMPERSONATE_KEY) || (0, cookies_1.getCookie)(exports.IMPERSONATE_KEY);
};
exports.impersonatingId = impersonatingId;
var impersonateStorageType = function () {
    if ((0, session_1.getSessionKey)(exports.IMPERSONATE_KEY))
        return 'session';
    if ((0, cookies_1.getCookie)(exports.IMPERSONATE_KEY))
        return 'cookie';
    return null;
};
exports.impersonateStorageType = impersonateStorageType;
var defaultHeaders = function (_a) {
    var anonymousToken = _a.anonymousToken, auth0Token = _a.auth0Token, body = _a.body, headers = _a.headers;
    var impersonateId = (0, exports.impersonatingId)();
    return __assign(__assign(__assign(__assign(__assign({}, (auth0Token && { Authorization: "Bearer ".concat(auth0Token) })), (anonymousToken && {
        'X-HankAuthorization': "Bearer ".concat(anonymousToken),
    })), ((0, browser_1.isBrowser)() && body instanceof FormData
        ? {}
        : { 'Content-Type': 'application/json' })), (impersonateId && { 'X-Impersonate-Id': impersonateId })), (headers !== null && headers !== void 0 ? headers : {}));
};
exports.defaultHeaders = defaultHeaders;
var request = function (_a) { return __awaiter(void 0, void 0, void 0, function () {
    var impersonateId, res, responseBody, error_1, defaultResponse, response, errors_1, err_1;
    var apiBase = _a.apiBase, path = _a.path, method = _a.method, body = _a.body, shouldThrow = _a.shouldThrow, tokens = __rest(_a, ["apiBase", "path", "method", "body", "shouldThrow"]);
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                impersonateId = (0, exports.impersonatingId)();
                _b.label = 1;
            case 1:
                _b.trys.push([1, 7, , 8]);
                return [4 /*yield*/, fetch("".concat(apiBase, "/").concat(path), {
                        method: method ? method : 'get',
                        body: body
                            ? (0, browser_1.isBrowser)() && body instanceof FormData
                                ? body
                                : JSON.stringify(body)
                            : null,
                        headers: (0, exports.defaultHeaders)(__assign(__assign({}, tokens), { body: body })),
                    })];
            case 2:
                res = _b.sent();
                responseBody = null;
                _b.label = 3;
            case 3:
                _b.trys.push([3, 5, , 6]);
                return [4 /*yield*/, res.json()];
            case 4:
                responseBody = _b.sent();
                return [3 /*break*/, 6];
            case 5:
                error_1 = _b.sent();
                if (res.status !== 204)
                    return [2 /*return*/, { error: error_1, status: res.status }];
                return [3 /*break*/, 6];
            case 6:
                defaultResponse = {
                    body: responseBody,
                    status: res.status,
                };
                if (!res.ok) {
                    response = __assign({ error: new Error('Something went wrong') }, defaultResponse);
                    if (res.status === 401) {
                        (0, api_token_1.clearAnonToken)();
                        response = __assign({ error: new Error('Need to authenticate'), isAuthError: true, body: responseBody }, defaultResponse);
                    }
                    if (responseBody.errors && responseBody.errors.length) {
                        response = __assign({ error: new Error(responseBody.errors[0]) }, defaultResponse);
                    }
                    else if (responseBody.errors) {
                        errors_1 = responseBody.errors;
                        response = __assign({ fieldErrors: Object.keys(errors_1).reduce(function (errs, key) {
                                var val = errors_1[key];
                                if (Array.isArray(val)) {
                                    errs[key] = val[0];
                                }
                                else {
                                    errs[key] = val;
                                }
                                return errs;
                            }, {}) }, defaultResponse);
                    }
                    else if (responseBody.error) {
                        response = __assign({ error: new Error(responseBody.error) }, defaultResponse);
                    }
                    if (shouldThrow) {
                        throw new ApplicationError_1.default(response);
                    }
                    else {
                        return [2 /*return*/, response];
                    }
                }
                // reset expiration on impersonation cookie upon successful API request
                if (impersonateId)
                    (0, exports.impersonate)(impersonateId, {
                        apiBase: apiBase,
                        storage: (0, exports.impersonateStorageType)(),
                    });
                return [2 /*return*/, __assign({}, defaultResponse)];
            case 7:
                err_1 = _b.sent();
                if (shouldThrow) {
                    throw err_1;
                }
                else {
                    return [2 /*return*/, { error: err_1, status: 500 }];
                }
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}); };
exports.request = request;
var useAuthedRequest = function (apiBase) {
    var _a = (0, api_token_1.useApiTokensWithReady)(apiBase), ready = _a.ready, tokens = __rest(_a, ["ready"]);
    if (!ready)
        return null;
    return function (args) { return (0, exports.request)(__assign(__assign(__assign({}, args), tokens), { apiBase: apiBase })); };
};
exports.useAuthedRequest = useAuthedRequest;
exports.useRequest = exports.useAuthedRequest;
//# sourceMappingURL=api.js.map